import React, { FC } from 'react';
import styles from './SecurityClassificationGuide.module.scss';
import {Helmet} from "react-helmet";

interface SecurityClassificationGuideProps {}

const SecurityClassificationGuide: FC<SecurityClassificationGuideProps> = () => (
  <div className={styles.SecurityClassificationGuide}>
    SecurityClassificationGuide Component
      <Helmet>
          <meta charSet="utf-8"/>
          <title>Security Classification Guide</title>
      </Helmet>
  </div>
);

export default SecurityClassificationGuide;
